import '@patsnap-ui/icon/assets/solid/CoreProductsBio.svg'
import { VUE_APP_BIO_URL } from '@pharmsnap/pharmsnap-web/config'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { openNewTab } from '@pharmsnap/shared/src/utils/business/dom'
import { defineComponent, PropType } from '@vue/composition-api'
import { uniqBy } from 'lodash'
import { Icon as PtIcon } from 'patsnap-biz'

export const BDrugModificationSimilarSequence = defineComponent({
  name: 'BDrugModificationSimilarSequence',
  props: {
    iconName: {
      type: String,
      default: 'SolidCoreProductsBio',
    },
    sequenceList: {
      type: Array as PropType<Array<{ sequence_hash_id: string }>>,
      required: true,
    },
    searchName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { tsText } = useLocale()
    const handleViewSimilarSequence = () => {
      const seqIdQuery = uniqBy(props.sequenceList, 'sequence_hash_id')
        .map((item) => `seqId=${item.sequence_hash_id}`)
        .join('&')

      openNewTab(`${VUE_APP_BIO_URL}/search.html#/jump-host?type=modification&searchName=${props.searchName}&${seqIdQuery}`)
    }

    return {
      tsText,
      handleViewSimilarSequence,
    }
  },
  render() {
    return (
      <div class="inline-flex items-center cursor-pointer gap-x-[2px] text-xs text-blue-default" onClick={this.handleViewSimilarSequence}>
        <PtIcon class="w-6 h-6" icon={this.iconName}></PtIcon>
        <div class="hover:underline">{this.tsText('查找相似序列修饰', 'View modification for similar sequences')}</div>
      </div>
    )
  },
})
